<template>
  <NuxtLink
    class="group block rounded-sm font-Spectral text-gray9 transition-shadow"
    :class="{ 'shadow-[0_0_0_2px_#a48953]': selected }"
    :data-pin-id="pin.id"
    :to="detailPath"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="mb-2 aspect-[3/2] w-full overflow-hidden rounded-sm bg-gray5">
      <OptimizedImage
        v-if="pin.thumbnailImageUrl"
        alt=""
        class="h-full w-full object-cover transition-transform duration-300 md:group-hover:scale-105"
        loading="lazy"
        :image-url="pin.thumbnailImageUrl"
        :optimized-image-options="{ width: 560 }"
      />
    </div>
    <div class="px-1">
      <p class="line-clamp-3 leading-5 tracking-tight text-gray9 md:text-[17px] md:leading-7 md:group-hover:text-gold3">{{ pin.name }}</p>
      <div class="mt-1 flex flex-wrap items-center text-sm text-gray4 md:text-base">
        <template v-if="pin.area">
          <p>{{ pin.area }}</p>
          <span class="px-1 text-[14px]">|</span>
        </template>
        <img alt="" class="my-auto h-4 w-4 -translate-y-px md:h-5 md:w-5" src="@/assets/icon/wabunka/clock-gray500.svg" />
        <p class="tracking-normal">
          {{ pin.experienceDuration?.value }}<span class="text-[11px] md:text-[14px]">{{ pin.experienceDuration?.unit }}</span>
        </p>
        <template v-if="priceLabel">
          <span class="px-1 text-[14px]">|</span>
          <p class="tracking-normal">{{ priceLabel }}</p>
        </template>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';
import { buildMapPinPriceLabel, type WabunkaExperienceMapPinViewModel } from '@/wabunka-src/common/features/Experience/models/wabunkaExperienceMapPin';
import { buildExperienceDetailPath } from '@/wabunka-src/common/features/Experience/utils/experienceDetailPath';

interface Props {
  pin: WabunkaExperienceMapPinViewModel;
  /** 選択中か（マップのピン選択に連動してハイライト表示する: F-14） */
  selected?: boolean;
  /** カードクリック時のコールバック（GA 送信・プレビュー閉じ等） */
  onClick?: (pin: WabunkaExperienceMapPinViewModel) => void;
  /** カードにホバーしたときのコールバック（対応ピンをハイライト: F-15） */
  onMouseEnter?: (pinId: string) => void;
  /** カードのホバーが外れたときのコールバック */
  onMouseLeave?: (pinId: string) => void;
}

const props = defineProps<Props>();

const priceLabel = computed<string>(() => buildMapPinPriceLabel(props.pin));
const detailPath = computed<string>(() => buildExperienceDetailPath(props.pin.slug));

const handleClick = () => {
  props.onClick?.(props.pin);
};

const handleMouseEnter = () => {
  props.onMouseEnter?.(props.pin.id);
};

const handleMouseLeave = () => {
  props.onMouseLeave?.(props.pin.id);
};
</script>
